import { createAction } from 'actions/utils'

export const ENTER_SIMULATE_MODE = 'ENTER_SIMULATE_MODE'
export const enterSimulateMode = createAction(ENTER_SIMULATE_MODE)

export const POPULATE_DEFAULT_SIMULATION_VALUES =
  'POPULATE_DEFAULT_SIMULATION_VALUES'
export const populateDefaultSimulationValues = createAction(
  POPULATE_DEFAULT_SIMULATION_VALUES,
  ['values']
)

export const EXIT_SIMULATE_MODE = 'EXIT_SIMULATE_MODE'
export const exitSimulateMode = createAction(EXIT_SIMULATE_MODE)

export const UPDATE_SIMULATED_VALUE = 'UPDATE_SIMULATED_VALUE'
export const updateSimulatedValue = createAction(UPDATE_SIMULATED_VALUE, [
  'uri',
  'value',
])

export const RESET_SIMULATED_VALUE = 'RESET_SIMULATED_VALUE'
export const resetSimulatedValue = createAction(RESET_SIMULATED_VALUE, [
  'conditionUri',
])

export const UPDATE_SIMULATION_EVALUATIONS = 'UPDATE_SIMULATION_EVALUATIONS'
export const updateSimulationEvaluations = createAction(
  UPDATE_SIMULATION_EVALUATIONS,
  ['values']
)

export const ADVANCE_TICK = 'ADVANCE_TICK'
export const advanceTick = createAction(ADVANCE_TICK)

export const RESET_CYCLES = 'RESET_CYCLES'
export const resetCycles = createAction(RESET_CYCLES)

export const PAUSE_SIMULATE_MODE = 'PAUSE_SIMULATE_MODE'
export const pauseSimulateMode = createAction(PAUSE_SIMULATE_MODE)

export const PLAY_SIMULATE_MODE = 'PLAY_SIMULATE_MODE'
export const playSimulateMode = createAction(PLAY_SIMULATE_MODE)

export const UPDATE_SIMULATION_SPEED = 'UPDATE_SIMULATION_SPEED'
export const updateSimulationSpeed = createAction(UPDATE_SIMULATION_SPEED, [
  'speed',
])

export const UPDATE_SIMULATED_OUTPUT_CURRENT = 'UPDATE_SIMULATED_OUTPUT_CURRENT'
export const updateSimulatedOutputCurrent = createAction(
  UPDATE_SIMULATED_OUTPUT_CURRENT,
  ['outputId', 'currentAmps']
)

export const OPEN_SIMULATED_FUSE = 'OPEN_SIMULATED_FUSE'
export const openSimulatedFuse = createAction(OPEN_SIMULATED_FUSE, [
  'outputId',
  'outputProps',
])

export const RESET_SIMULATED_FUSE = 'RESET_SIMULATED_FUSE'
export const resetSimulatedFuse = createAction(RESET_SIMULATED_FUSE, [
  'outputId',
  'retries',
])

export const TIME_REMAINING_VIRTUAL_FUSE_RESET =
  'UPDATE_TIME_REMAINING_VIRTUAL_FUSE_RESET'
export const updateTimeRemainingVirtualFuseReset = createAction(
  TIME_REMAINING_VIRTUAL_FUSE_RESET,
  ['outputId', 'timeRemainingMs']
)
